import { ServiceResponse } from "../../api/ServiceResponse";

export class ReportResponse extends ServiceResponse {
  data?: Uint8Array; // corresponds to Java byte[]
  contentType?: string | { type: string; subtype: string; parameters?: any }; // MediaType as string (e.g., 'application/pdf')

  constructor(init?: Partial<ReportResponse>) {
    super(init);
    Object.assign(this, init);

    // normalize MediaType from backend (object or string)
    if (
      this.contentType &&
      typeof this.contentType === "object" &&
      "type" in this.contentType &&
      "subtype" in this.contentType
    ) {
      const ct = this.contentType as { type: string; subtype: string };
      this.contentType = `${ct.type}/${ct.subtype}`;
    }
  }

  // Getters & Setters
  getData(): Uint8Array | undefined {
    return this.data;
  }
  setData(value: Uint8Array | undefined): void {
    this.data = value;
  }

  getContentType(): string | undefined {
    return this.contentType as string;
  }
  setContentType(value: string | undefined): void {
    this.contentType = value;
  }
}
